export default function Navegacao (_href, _target) {
    if(_target)
        window.open(_href, _target);
    else
        window.location.href = _href;
}
